module.exports = function getResource(label, vars = []) {
    let resources = {
        add: 'Add',
        remove: 'Remove',
        addedText: 'Added'
    };

    return resources[label];
};
